module.exports = __webpack_public_path__ + "static/img/COC2023-22.ebe7ef0.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/meeting2023/COC2023-22.png
// module id = w0Cv
// module chunks = 0